import { buildEndpointUrl } from '@/_shared/helpers/makeSwaggerToEndpointUrl';
import { payloadToQueryParamsUrl } from '@/_shared/helpers/payloadToQueryParamsUrl';
import { GenericGet } from '@/_shared/types/swagger';
import {
  API_ORGANIZATIONS_ORGANIZATIONID_SURVEYS_CAMPAIGNS_CAMPAIGNID_RESPONSES_RESULTS_STATS_PATH_KEY,
  API_ORGANIZATIONS_ORGANIZATIONID_SURVEYS_CAMPAIGNS_CAMPAIGNID_RESPONSES_STATS_PATH_KEY,
  API_ORGANIZATIONS_ORGANIZATIONID_SURVEYS_CAMPAIGNS_ID_PATH_KEY,
  API_ORGANIZATIONS_ORGANIZATIONID_SURVEYS_CAMPAIGNS_ID_REMINDER_PATH_KEY,
  API_ORGANIZATIONS_ORGANIZATIONID_SURVEYS_CAMPAIGNS_INVITATION_TEMPLATES_TEMPLATEID_VERSIONID_PATH_KEY,
  API_ORGANIZATIONS_ORGANIZATIONID_SURVEYS_CAMPAIGNS_PATH_KEY,
  API_ORGANIZATIONS_ORGANIZATIONID_SURVEYS_USER_NOTCOMPLETED_PATH_KEY,
  API_ORGANIZATIONS_ORGANIZATIONID_SURVEYS_USERS_PATH_KEY,
  API_ORGANIZATIONS_ORGANIZATIONID_SURVEYS_CAMPAIGNS_ID_NEXT_PATH_KEY,
  API_TEMPLATES_ID_PATH_KEY,
  API_TEMPLATES_PATH_KEY,
  API_ORGANIZATIONS_ORGANIZATIONID_SURVEYS_CAMPAIGNS_ID_END_PATH_KEY,
  API_ORGANIZATIONS_ORGANIZATIONID_SURVEYS_CAMPAIGNS_ID_VISIBILITY_PATH_KEY,
  API_ORGANIZATIONS_ORGANIZATIONID_SURVEYS_CAMPAIGNS_RESULTS_STATS_PATH_KEY,
  API_TEMPLATES_ID_SIMULATE_PATH_KEY,
} from '@/swagger/constants/surveys-keys';

type RequestQueryGetSurveysCampaigns = GenericGet<
  typeof API_ORGANIZATIONS_ORGANIZATIONID_SURVEYS_CAMPAIGNS_PATH_KEY
>['request']['query'];

export const API_GET_SURVEYS_CAMPAIGNS_CALL = (
  org: string,
  payload: RequestQueryGetSurveysCampaigns,
) => {
  const baseUrl = buildEndpointUrl(API_ORGANIZATIONS_ORGANIZATIONID_SURVEYS_CAMPAIGNS_PATH_KEY, {
    organizationId: org,
  });
  return payloadToQueryParamsUrl(payload, baseUrl);
};

export const API_POST_SURVEYS_CAMPAIGNS_CALL = (org: string) => {
  return buildEndpointUrl(API_ORGANIZATIONS_ORGANIZATIONID_SURVEYS_CAMPAIGNS_PATH_KEY, {
    organizationId: org,
  });
};

export const API_GET_SURVEY_CAMPAIGN_BY_ID_CALL = (org: string, campaignId: string) => {
  return buildEndpointUrl(API_ORGANIZATIONS_ORGANIZATIONID_SURVEYS_CAMPAIGNS_ID_PATH_KEY, {
    organizationId: org,
    id: campaignId,
  });
};

export const API_PUT_SURVEY_CAMPAIGN_BY_ID_CALL = (org: string, campaignId: string) => {
  return buildEndpointUrl(API_ORGANIZATIONS_ORGANIZATIONID_SURVEYS_CAMPAIGNS_ID_PATH_KEY, {
    organizationId: org,
    id: campaignId,
  });
};

export const API_GET_SURVEYS_TEMPLATES_CALL = () => {
  return buildEndpointUrl(API_TEMPLATES_PATH_KEY, {});
};

export const API_GET_SURVEYS_TEMPLATE_BY_ID_CALL = (templateId: string) => {
  return buildEndpointUrl(API_TEMPLATES_ID_PATH_KEY, { id: templateId });
};

export const API_GET_SURVEYS_CAMPAIGN_INVITATION_BY_TEMPLATE_ID_CALL = (
  org: string,
  templateId: string,
  versionId: string,
  campaignId?: string,
) => {
  const baseUrl = buildEndpointUrl(
    API_ORGANIZATIONS_ORGANIZATIONID_SURVEYS_CAMPAIGNS_INVITATION_TEMPLATES_TEMPLATEID_VERSIONID_PATH_KEY,
    { templateId, versionId, organizationId: org },
  );

  return payloadToQueryParamsUrl({ campaignId }, baseUrl);
};

export const API_POST_SURVEYS_CAMPAIGNS_ID_REMINDER = (org: string, campaignId: string) => {
  return buildEndpointUrl(API_ORGANIZATIONS_ORGANIZATIONID_SURVEYS_CAMPAIGNS_ID_REMINDER_PATH_KEY, {
    organizationId: org,
    id: campaignId,
  });
};

export const API_GET_SURVEYS_CAMPAIGNS_ID_REMINDER_EMPLOYEES = (
  org: string,
  campaignId: string,
) => {
  return buildEndpointUrl(API_ORGANIZATIONS_ORGANIZATIONID_SURVEYS_CAMPAIGNS_ID_REMINDER_PATH_KEY, {
    organizationId: org,
    id: campaignId,
  });
};

export const API_GET_SURVEY_CAMPAIGN_BY_ID_RESPONSES_STATS = (org: string, campaignId: string) => {
  return buildEndpointUrl(
    API_ORGANIZATIONS_ORGANIZATIONID_SURVEYS_CAMPAIGNS_CAMPAIGNID_RESPONSES_STATS_PATH_KEY,
    {
      organizationId: org,
      campaignId,
    },
  );
};

export const API_GET_SURVEY_CAMPAIGN_BY_ID_RESPONSES_RESULTS_STATS = (
  org: string,
  campaignId: string,
  departmentId?: string,
  teamId?: string,
) => {
  const baseUrl = buildEndpointUrl(
    API_ORGANIZATIONS_ORGANIZATIONID_SURVEYS_CAMPAIGNS_CAMPAIGNID_RESPONSES_RESULTS_STATS_PATH_KEY,
    {
      organizationId: org,
      campaignId,
    },
  );

  return payloadToQueryParamsUrl({ departmentId, teamId }, baseUrl);
};

export const API_GET_EMPLOYER_NOT_COMPLETED_SURVEYS = (org: string) => {
  return buildEndpointUrl(API_ORGANIZATIONS_ORGANIZATIONID_SURVEYS_USER_NOTCOMPLETED_PATH_KEY, {
    organizationId: org,
  });
};

export const API_POST_EMPLOYER_BY_ID_SURVEY_RESULT = (organizationId: string) => {
  return buildEndpointUrl(API_ORGANIZATIONS_ORGANIZATIONID_SURVEYS_USERS_PATH_KEY, {
    organizationId,
  });
};

export const API_POST_SURVEYS_CAMPAIGNS_ID_NEXT = (org: string, campaignId: string) => {
  return buildEndpointUrl(API_ORGANIZATIONS_ORGANIZATIONID_SURVEYS_CAMPAIGNS_ID_NEXT_PATH_KEY, {
    organizationId: org,
    id: campaignId,
  });
};

export const API_POST_SURVEYS_CAMPAIGNS_ID_END = (org: string, campaignId: string) => {
  return buildEndpointUrl(API_ORGANIZATIONS_ORGANIZATIONID_SURVEYS_CAMPAIGNS_ID_END_PATH_KEY, {
    organizationId: org,
    id: campaignId,
  });
};

export const API_PUT_SURVEY_CAMPAIGN_VISIBILITY_CALL = (org: string, campaignId: string) => {
  return buildEndpointUrl(
    API_ORGANIZATIONS_ORGANIZATIONID_SURVEYS_CAMPAIGNS_ID_VISIBILITY_PATH_KEY,
    {
      organizationId: org,
      id: campaignId,
    },
  );
};

export const API_GET_SURVEY_CAMPAIGNS_RESULTS_STATS = (
  org: string,
  params: GenericGet<
    typeof API_ORGANIZATIONS_ORGANIZATIONID_SURVEYS_CAMPAIGNS_RESULTS_STATS_PATH_KEY
  >['request']['query'],
) => {
  const baseUrl = buildEndpointUrl(
    API_ORGANIZATIONS_ORGANIZATIONID_SURVEYS_CAMPAIGNS_RESULTS_STATS_PATH_KEY,
    {
      organizationId: org,
    },
  );

  return payloadToQueryParamsUrl(params, baseUrl);
};

export const API_POST_TEMPLATE_SIMULATE = (templateId: string) => {
  return buildEndpointUrl(API_TEMPLATES_ID_SIMULATE_PATH_KEY, { id: templateId });
};
